import { useAiAgentLayout } from 'app/components/ai-agent-layout/useAiAgentLayout'
import { AiAgentLayoutShadcnComponent } from 'app/components/ai-agent-layout/AiAgentLayoutShadcnComponent'

export const handle = {
  title: `AI Agent`,
  breadcrumb: `AI Agent`,
}

export default function AIAgent(): React.ReactElement {
  const { children } = useAiAgentLayout()
  return <AiAgentLayoutShadcnComponent>{children}</AiAgentLayoutShadcnComponent>
}
